export enum RoutePlanTimespan {
    weekly='weekly',
    biweekly='biweekly',
    monthly='monthly',
    quarterly='quarterly',
    yearly='yearly',
    tour='tour',
}
